import React, {useEffect, useState} from "react";

// Styles
import DublinAsiaContainer from "./DublinAsia.styles";

// Components
import Latest from "components/Screens/Fees/Common/FundTabs/LatestTab/Latest";
import Reports from "components/Screens/Fees/Common/FundTabs/ReportsTab/Reports";
import SubTabs from "components/Common/SubTabs/SubTabs";
import Archive from "components/Screens/Fees/Common/FundTabs/ArchiveTab/Archive";

//utils
import {FeesReportDetails, setFeesReportDetails} from "utils/fees.utils";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface DublinAsiaProps {
    region: string;
}

const DublinAsia = ({ region }: DublinAsiaProps) => {
    const [feesForcastReportDetails, setFeesForcastReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });
    const [feesDiscrepancyReportDetails, setFeesDiscrepancyReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });
    const [feesMonthlyReportDetails, setFeesMonthlyReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });

    useEffect(() => {
        setFeesReportDetails("DUBLIN_ASIA_FEES", setFeesForcastReportDetails);
        setFeesReportDetails("DUBLIN_ASIA_DISCREPANCY", setFeesDiscrepancyReportDetails);
        setFeesReportDetails("DUBLIN_ASIA_MONTHLY", setFeesMonthlyReportDetails);
    }, []);

    return (
        <DublinAsiaContainer>
            <SubTabs
                defaultTab="latest"
                subTabs={[
                    {
                        value: "latest",
                        title: "LATEST",
                        content: <Latest region={region} fund="dublin" period="latest" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "reports",
                        title: "REPORTS SIGN OFF",
                        content: <Reports region={region} fund="dublin" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "fee_report",
                        title: "FEE REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesForcastReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesForcastReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesForcastReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "discrepancy_report",
                        title: "DISCREPANCY REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesDiscrepancyReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesDiscrepancyReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesDiscrepancyReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "monthly_report",
                        title: "MONTHLY NAV REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesMonthlyReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesMonthlyReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesMonthlyReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "archive",
                        title: "ARCHIVE",
                        content: <Archive fund="dublin" region="asia" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                ]}
            />
        </DublinAsiaContainer>
    );
};
export default DublinAsia;
